import i18n from '@/lang/i18n'

export default (value, index = 0, length = 1) => {
    if (length === 1 || length === index + 1) return value
    if (length === index + 2) return value + i18n.t('general.and')
    return `${value}, `
}
